var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-keyboard-button",on:{"click":function($event){return _vm.toggleCtrlLayout()}}},[_vm._v(" Toggle ⌘/Ctrl ")])}
var staticRenderFns = []

export { render, staticRenderFns }